import { Alignment, Button, ButtonVariant, Intent, Position, Tooltip } from "@blueprintjs/core"; 
import { __ } from "../utilities";
import { showToast } from "./AppToaster";

export interface IClipboardCopyProps {
    data: any
    isNotTrim?: boolean
    label?: string
    position?: Position
    answer?: string
    type?: "button" | "icon"
    fill?: boolean
    className?: string
    intent? : Intent
    onClick? : (evt: any) => void
    variant?: ButtonVariant 
    align?: Alignment
}
const ClipboardCopyBtn = (props: IClipboardCopyProps) : JSX.Element => {
    const copy = async ( evt: any ) =>
    { 
        copyClipboard(props)
        if(props.onClick) {
            props.onClick(evt)
        } 
    }
    return props.type === "button"    
        ?
        <Button variant={props.variant || "minimal"} onClick={ copy } fill={!!props.fill} intent={props.intent} alignText={props.align} >
            <div className={`d-flex flex-nowrap ${props.className}`}>
                <i className="fas fa-clone mr-2" /> 
                <span className={`small letter-spacing-1`}>{ __( props.label || "Copy to clipboard") }</span>
            </div>
        </Button>
        :
        <Tooltip content={ __( props.label || "Copy to clipboard") } position={props.position} interactionKind="hover">
            <div className='btn btn-link text-secondary w-100 btn-sm ' onClick={ copy } >
                <i className="fas fa-clone" /> 
            </div>
        </Tooltip>
} 

export default ClipboardCopyBtn 

export const copyClipboard = async ( props: Partial<IClipboardCopyProps> ) =>
    {
        const data = JSON.stringify( props.data ) 
        const elemDiv = document.createElement('div');
        elemDiv.style.cssText = 'position:absolute; z-index:-100; width:100%; top:0; left:0;'
        elemDiv.setAttribute("id", "myInputCont")
        const textarea = document.createElement("textarea")
        textarea.setAttribute("id", "myInput")
        elemDiv.appendChild(textarea)
        if(!!props.isNotTrim) {
            textarea.value = data.trim()
        }
        else {
            textarea.value = data.substring(1)
            textarea.value = textarea.value.substring(0, data.length - 2) 
        } 
        document.body.appendChild( elemDiv )
		const copyText: HTMLTextAreaElement = document.getElementById("myInput") as HTMLTextAreaElement
		copyText.select()
		copyText.setSelectionRange(0, 99999999999999999999)
		document.execCommand("copy")
        document.getElementById("myInputCont")!.remove() 
		showToast({
			intent: Intent.SUCCESS,
			icon: "tick", 
			message: __( props.answer || "Copied success" ),
		})
    }